import { render, staticRenderFns } from "./kisaeDataDetail.vue?vue&type=template&id=50332edc&scoped=true"
import script from "./kisaeDataDetail.vue?vue&type=script&lang=js"
export * from "./kisaeDataDetail.vue?vue&type=script&lang=js"
import style0 from "./kisaeDataDetail.vue?vue&type=style&index=0&id=50332edc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50332edc",
  null
  
)

export default component.exports